export const MIN_WORD_LENGTH = 2
export const MAX_WORD_LENGTH = 5
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const GAME_LOST_INFO_DELAY = REVEAL_TIME_MS
export const WELCOME_INFO_MODAL_MS = 350
